import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { PageLayout } from '../../PageLayout';
import { userAgent } from '@uhg-abyss/web/tools/userAgent';

const BottomSectionSpacing = styled('div', {
  height: 100,

  '@media print': {
    height: 60,
  },
});

const HeaderOverlay = styled('div', {
  position: 'absolute',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1200,
  display: 'none',

  '.header-overlay-active &': {
    display: 'block',
  },
});

const BackButtonContainer = styled(Flex.Content, {
  lineHeight: '14px',
});

const BackButton = styled('button', {
  static: {
    position: 'relative',
    marginRight: 10,
    width: 34,
    height: 34,
    borderRadius: '50%',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$primary1',
    background: '$primary2',
  },
  dynamic: ({ isIE }) => {
    return {
      marginTop: isIE ? 2 : 5,
    };
  },
});

const BottomSection = styled('div', {
  backgroundColor: '$primary2',
  variants: {
    variant: {
      noSticky: {
        paddingTop: 5,
        paddingBottom: 5,
      },
      sticky: {
        boxShadow: '0 8px 8px -6px rgba(0, 0, 0, 0.2)',
      },
    },

    defaultVariants: {
      variant: 'noSticky',
    },
  },
});

export const PageHeaderBottom = ({
  children,
  showBackButton,
  customGoBack,
  isSticky,
  backButtonContainer,
}) => {
  const router = useRouter();

  const handleGoBack = () => {
    if (customGoBack) {
      customGoBack();
    } else {
      router.navigate(-1);
    }
  };

  return (
    <React.Fragment>
      <BottomSection variant={isSticky ? 'sticky' : 'noSticky'}>
        <PageLayout>
          <Choose>
            <When condition={showBackButton}>
              <Flex>
                <BackButtonContainer space-self>
                  <BackButton
                    type="button"
                    onClick={handleGoBack}
                    aria-label="Back"
                    data-testid="header-back-button"
                    cssProps={{ isIE: userAgent.isIE }}
                  />
                </BackButtonContainer>
                <Flex.Content>{children}</Flex.Content>
              </Flex>
            </When>
            <Otherwise>{children}</Otherwise>
          </Choose>
        </PageLayout>
        <If condition={isSticky}>
          <HeaderOverlay />
        </If>
      </BottomSection>
      <If condition={isSticky}>
        <BottomSectionSpacing />
      </If>
    </React.Fragment>
  );
};

PageHeaderBottom.propTypes = {
  children: PropTypes.node,
  isSticky: PropTypes.bool,
  showBackButton: PropTypes.bool,
  customGoBack: PropTypes.func,
  backButtonContainer: PropTypes.string,
};

PageHeaderBottom.defaultProps = {
  children: null,
  isSticky: true,
  showBackButton: true,
  customGoBack: null,
  backButtonContainer: null,
};
